import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";
import FloatingContact from "@/components/site/FloatingContact";
import Marquee from "@/components/site/Marquee";
import Hero from "@/components/sections/Hero";
import TravelSection from "@/components/sections/TravelSection";
import ServicesSection from "@/components/sections/ServicesSection";
import StepsSection from "@/components/sections/StepsSection";
import PricingSection from "@/components/sections/PricingSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import ContactSection from "@/components/sections/ContactSection";

function scrollTo(sel) {
  const el = document.querySelector(sel);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export default function Home() {
  const toContact = () => scrollTo("#contacto");
  const toPlanes = () => scrollTo("#precios");

  return (
    <div className="bg-white" data-testid="home-page">
      <Header />
      <main>
        <Hero onCta={toContact} onPlanes={toPlanes} />
        <Marquee />
        <TravelSection onCta={toContact} />
        <ServicesSection />
        <StepsSection />
        <PricingSection onCta={toContact} />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
      <CookieBanner />
      <FloatingContact />
    </div>
  );
}
